import { Button, Grid } from "@material-ui/core";
import { Auth } from "aws-amplify";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./genai.css";

export default function Demo() {
  const [genaiaccess, setgenaiaccess] = useState(false);

  useEffect(() => {
    const username = localStorage.getItem(
      "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
    );
    const userdata = localStorage.getItem(
      `CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.${username}.userData`,
    );
    const jsondata = JSON.parse(userdata);
    const emailObj = jsondata.UserAttributes.find(
      (item) => item.Name === "email",
    );
    const email = emailObj?.Value || "";

    setgenaiaccess(email.includes("genai2244"));
  }, []);

  async function signOut() {
    try {
      await Auth.signOut({ global: true });
      window.location.reload();
    } catch (error) {
      // console.log('error signing out: ', error);
    }
  }
  return (
    <div>
      <div>
        <img
          id="backgroundmainimageoverlay"
          src="/assets/images/background/g7.mp4"
          alt="background-img"
          style={{
            filter: "opacity(0.2)",
            position: "fixed",
            zIndex: "-3",
            width: "100vw",
            height: "110vh",
            marginTop: "-10vh",
            overflow: "hidden",
          }}
        />
        <img
          style={{ zIndex: "-4" }}
          id="backgroundmainimage"
          src="/assets/images/background/MainBackground.png"
          alt="main-background-img"
        />
      </div>
      <div className="container-fluid navcontent">
        <div className="row justify-content-between">
          <div className="col-auto align-self-end">
            <div>
              <Grid
                style={{ display: "flex", position: "relative", zIndex: "4" }}
              >
                <Link to="/">
                  <Button variant="contained" component="span" color="primary">
                    Back
                  </Button>
                </Link>
              </Grid>
            </div>
          </div>
          <div className="col-auto align-self-end basicheader">
            <h2 style={{ paddingTop: "10vh !important", fontWeight: "bold" }}>
              Generative AI for Business
            </h2>
          </div>
          <div className="col-auto align-self-end">
            {/* <Link to="/" style={{paddingRight:"2vw"}}>
                                <Button  variant="contained" color="primary" >Home</Button>
                            </Link> */}
            <Button
              style={{
                backgroundColor: "#ffa502",
                position: "relative",
                zIndex: "4",
              }}
              variant="contained"
              onClick={() => {
                signOut();
              }}
              color="primary"
              component="span"
            >
              Sign Out
            </Button>
          </div>
        </div>
      </div>

      {genaiaccess ? (
        <div>
          <div className="exp-container" style={{ width: "90vw" }}>
            <div className="exp">
              <h2>Human Resource</h2>
              <img
                className="exp-img"
                src="/assets/images/hr-man.jpg"
                alt="exp-img"
              />
              <Link to="/gen-ai-hr-section">
                <p>Open</p>
              </Link>
            </div>
            <div className="exp">
              <h2>Sales & Marketing</h2>
              <img
                className="exp-img"
                src="/assets/images/sales-man.jpg"
                alt="exp-img"
              />
              <Link to="/gen-ai-marketing-section">
                <p>Open</p>
              </Link>
            </div>
            <div className="exp">
              <h2>Finance</h2>
              <img
                className="exp-img"
                src="/assets/images/finance-man.jpg"
                alt="exp-img"
              />
              <Link to="/finance">
                <p>Open</p>
              </Link>
            </div>

            {/* <div className='exp'>
          <h2>Data Analytics</h2>
          <Link to="/data-analytics"><p>Open</p></Link>
        </div> */}
          </div>
          <div className="exp-container" style={{ width: "90vw" }}>
            <div className="exp">
              <h2>Business Manufacturing</h2>
              <img
                className="exp-img"
                src="/assets/images/bussiness-man.jpg"
                alt="exp-img"
              />
              <Link to="/bussinesss-manufacturing">
                <p>Open</p>
              </Link>
            </div>
            {/* <div className="exp">
              <h2>Supply Chain</h2>
              <img className="exp-img" src="./assets/images/sales.jpg" />
              <Link to="/supply-chain">
                <p>Open</p>
              </Link>
            </div> */}
            <div className="exp">
              <h2>
                Managerial Conversations <br /> Training
              </h2>
              <img
                className="exp-img"
                src="/assets/images/feedback-coach.jpg"
                alt="exp-img"
              />
              <Link to="/feedback-coach">
                <p>Open</p>
              </Link>
            </div>
            <div className="exp">
              <h2>Sales Training</h2>
              <img
                className="exp-img"
                src="/assets/images/sale-training1.jpg"
                alt="exp-img"
              />
              <Link to="/sales-training">
                <p>Open</p>
              </Link>
            </div>
          </div>
          <div className="exp-container" style={{ width: "90vw" }}>
            <div className="exp">
              <h2>Audit</h2>
              <img
                className="exp-img"
                src="/assets/images/bussiness-man.jpg"
                alt="exp-img"
              />
              <Link to="/audit-coach">
                <p>Open</p>
              </Link>
            </div>
          </div>
        </div>
      ) : (
        <h2 style={{ color: "white", textAlign: "center" }}>
          You do not have an access to use this section.
        </h2>
      )}
    </div>
  );
}
